import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { ApiConfiguration } from '@core/api/angular';
import { AMPLIFY_OUTPUTS, IS_EMBEDDED } from '@lassi/config';
import {
  provideEmbeddedQuickSearchTypeList,
  ROUTE_STORAGE,
} from '@lassi/webapp-shared';
import { firstValueFrom } from 'rxjs';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withComponentInputBinding()),
    provideAnimationsAsync(),
    provideNativeDateAdapter(),
    provideAppInitializer(() => firstValueFrom(inject(AMPLIFY_OUTPUTS))),
    provideEmbeddedQuickSearchTypeList(),
    { provide: ApiConfiguration, useValue: { rootUrl: '/api/core' } },
    {
      provide: IS_EMBEDDED,
      useValue: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'en-AU',
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    {
      provide: ROUTE_STORAGE,
      useValue: window.sessionStorage,
    },
  ],
};
